import { removeClass, addClass } from '@utils/domUtils';
import { loadGmapApi } from '@utils/gmap';
import { GOOGLE_MAPS_API_KEY } from '@config';

/* global google, jQuery */

export default class PlaceSelect {
  static selectorString() {
    return '.PlaceSelect';
  }

  render(node, props) {
    loadGmapApi(GOOGLE_MAPS_API_KEY, this.ready.bind(this));
  }

  ready() {
    const addressInput = this.node.querySelector('.input-address');
    const cityInput = this.node.querySelector('.input-city');
    const countryInput = this.node.querySelector('.input-country');
    const streetInput = this.node.querySelector('.input-street');
    const zipCodeInput = this.node.querySelector('.input-zipCode');
    const placeInput = this.node.querySelector('.input-place');
    const detailFields = this.node.querySelector('.detail-fields');
    const buttonEnterManually = this.node.querySelector('.button-enter-manually');
    const buttonEnterManuallyWrapper = this.node.querySelector('.button-enter-manually-wrapper');

    buttonEnterManually.addEventListener('click', () => {
      removeClass(detailFields, 'hide');
      addClass(buttonEnterManuallyWrapper, 'hide');
    });

    const autocomplete = new google.maps.places.Autocomplete(addressInput, { types: ['address'] });
    autocomplete.setFields(['address_components']);
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();

      if (!place.address_components) {
        return;
      }

      const streetNumberComponent = place.address_components.find(
        addr => addr.types.indexOf('street_number') !== -1,
      );
      const streetAddressComponent = place.address_components.find(
        addr => addr.types.indexOf('route') !== -1,
      );
      const cityComponent = place.address_components.find(
        addr => addr.types.indexOf('locality') !== -1,
      );
      const countryComponent = place.address_components.find(
        addr => addr.types.indexOf('country') !== -1,
      );
      const zipCodeComponent = place.address_components.find(
        addr => addr.types.indexOf('postal_code') !== -1,
      );

      const streetAddress = streetAddressComponent ? streetAddressComponent.long_name : null;
      const streetNumber = streetNumberComponent ? streetNumberComponent.long_name : null;
      const city = cityComponent ? cityComponent.long_name : null;
      const country = countryComponent ? countryComponent.short_name : null;
      const zipCode = zipCodeComponent ? zipCodeComponent.long_name : null;

      streetInput.value = [streetAddress, streetNumber].filter(Boolean).join(' ');
      cityInput.value = city;
      countryInput.value = country;
      zipCodeInput.value = zipCode;
      placeInput.value = JSON.stringify(place.address_components);

      jQuery(countryInput).trigger('change');

      removeClass(detailFields, 'hide');
      addClass(buttonEnterManuallyWrapper, 'hide');
    });

    // NOTE: dirty hack: resets autocomplete on input to `none` to prevent showing autocomplete results...
    for (let i = 1; i < 10; i++) {
      setTimeout(this.setAutocompleteNone.bind(this), 500 * i);
    }
  }

  setAutocompleteNone() {
    this.node.querySelector('.input-address').setAttribute('autocomplete', 'none');
  }
}
